import React from 'react';
import { clsx } from '@components/Provider';
import { CustomizedTypography } from '@components/Customized';
import { Box, makeStyles } from '@material-ui/core';
import { ArrowBackIosOutlined } from '@material-ui/icons';

const useStyles = makeStyles(() => {
  return {
    root: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      '& .MuiSvgIcon-root': {
        cursor: 'pointer'
      }
    }
  };
});

interface Props {
  matches?: boolean;
  className?: string;
  title?: string;
  extra?: React.ReactNode;
  onClick?: () => void;
}

const RfqDetailHeaderPresenter: React.FC<Props> = ({
  matches,
  className,
  title,
  extra,
  onClick
}) => {
  const classes = useStyles({ matches });

  return (
    <Box className={clsx(classes.root, className ? className : '')}>
      <ArrowBackIosOutlined onClick={onClick} />
      <CustomizedTypography
        variant="body1"
        fontWeight="500"
        color="textPrimary"
      >
        {title}
      </CustomizedTypography>
      {extra ? extra : <div></div>}
    </Box>
  );
};

export default RfqDetailHeaderPresenter;
